import { render, staticRenderFns } from "./ParametersPanel.vue?vue&type=template&id=bc44c042&"
import script from "./ParametersPanel.vue?vue&type=script&lang=js&"
export * from "./ParametersPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports